import { render, staticRenderFns } from "./OrderLDItemEdit.vue?vue&type=template&id=1f5bdc7e&scoped=true"
import script from "./OrderLDItemEdit.vue?vue&type=script&lang=js"
export * from "./OrderLDItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5bdc7e",
  null
  
)

export default component.exports